/*
 * Copyright (c) Nexign, JSC, 2023-2024.
 */
/**
 *
 *
 * @author Evgeniy Naumov
 * @author Ilya Baranchikov
 * @version 1.28.0
 * @since 1.25.1
 */

import { ELogBusinessEventName, ELogBusinessEventType } from '@/main/modules/logging';
import { ITableInitialise } from '@/main/modules/table/types';

export const HISTORY_INQUIRY_TABLE_CONFIG: ITableInitialise = {
    meta: {
        url: 'inquiry/meta',
    },
    list: {
        url: 'inquiry/list',
        log: {
            eventName: ELogBusinessEventName.B2B_INQUIRIES,
            type: ELogBusinessEventType.common,
        },
    },
    filterAndSort: {
        url: 'inquiry/filter-and-sort',
        preset: 'inquiry/filter-and-sort-preset',
        suggest: 'inquiry/suggest',
    },
    resize: {
        url: 'inquiry/fields/resize',
    },
};

export const HISTORY_INQUIRY_EXPORT_URL = 'inquiry/export';

export const OTHER_INQUIRY_TABLE_CONFIG: ITableInitialise = {
    meta: {
        url: 'other-inquiry/meta',
    },
    list: {
        url: 'other-inquiry/list',
        log: {
            eventName: ELogBusinessEventName.B2B_SHOW_OTHER_INQUIRIES,
            type: ELogBusinessEventType.common,
        },
    },
    filterAndSort: {
        url: 'other-inquiry/filter-and-sort',
        preset: 'other-inquiry/filter-and-sort-preset',
        suggest: 'other-inquiry/suggest',
    },
    resize: {
        url: 'other-inquiry/fields/resize',
    },
};

export const OTHER_INQUIRY_EXPORT_URL = 'other-inquiry/export';

export const HISTORY_INQUIRY_INIT_ONBOARDING = '@@b2b_portal_ui/inquiries/INIT_ONBOARDING';
